import type { VisitFilters } from "../../types/domain";
import { Field } from "../common/Field";

type VisitFiltersPanelProps = {
  filters: VisitFilters;
  onChange: (nextFilters: VisitFilters) => void;
  onClear: () => void;
  onRefresh: () => void;
  onExport: () => void;
  isBusy: boolean;
  isExporting: boolean;
};

export function VisitFiltersPanel({
  filters,
  onChange,
  onClear,
  onRefresh,
  onExport,
  isBusy,
  isExporting,
}: VisitFiltersPanelProps) {
  const hasActiveFilters = Object.values(filters).some((value) => value.trim() !== "");

  return (
    <section className="admin-panel admin-filters" aria-label="Filtri e strumenti">
      <div className="admin-filters__fields">
        <Field
          label="Data visita"
          inputProps={{
            type: "date",
            value: filters.date,
            onChange: (event) => onChange({ ...filters, date: event.target.value }),
          }}
        />
        <Field
          label="Nome"
          inputProps={{
            type: "search",
            value: filters.firstName,
            onChange: (event) =>
              onChange({ ...filters, firstName: event.target.value }),
            placeholder: "Cerca per nome",
          }}
        />
        <Field
          label="Cognome"
          inputProps={{
            type: "search",
            value: filters.lastName,
            onChange: (event) =>
              onChange({ ...filters, lastName: event.target.value }),
            placeholder: "Cerca per cognome",
          }}
        />
        <Field
          label="Azienda"
          inputProps={{
            type: "search",
            value: filters.company,
            onChange: (event) => onChange({ ...filters, company: event.target.value }),
            placeholder: "Cerca per azienda",
          }}
        />
      </div>
      <div className="admin-filters__actions">
        <button
          className="ghost-button ghost-button--sm"
          type="button"
          onClick={onClear}
          disabled={!hasActiveFilters}
        >
          Azzera filtri
        </button>
        <button
          className="ghost-button ghost-button--sm"
          type="button"
          onClick={onRefresh}
          disabled={isBusy}
        >
          {isBusy ? "Aggiornamento..." : "Aggiorna"}
        </button>
        <button
          className="primary-button primary-button--sm"
          type="button"
          onClick={onExport}
          disabled={isExporting}
        >
          {isExporting ? "Esportazione..." : "Esporta CSV"}
        </button>
      </div>
    </section>
  );
}
